import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RestartAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"restart_alt"}/>
}
